module.exports = __webpack_public_path__ + "static/media/ios-tv.5a506830.svg";